module.exports = __webpack_public_path__ + "static/media/ToyotaType-Regular.d4af9024.otf";